<template>
  <p
    class="ai-generated-disclosure"
    :class="{ 'ai-generated-disclosure--competencies': variant === 'competencies' }"
    data-cy="ai-generated-disclosure"
  >
    {{ disclosureText }}
  </p>
</template>

<style scoped>
.ai-generated-disclosure {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--kate-type-secondary, var(--kate-type-primary));
  font-style: italic;
}

.ai-generated-disclosure--competencies {
  margin: 0;
  font-style: normal;
  width: 100%;
  color: var(--kate-warning) !important;
}
</style>

<style>
[data-theme="dark"] .ai-generated-disclosure,
[data-theme="legacy"] .ai-generated-disclosure {
  color: var(--kate-warning) !important;
}

[data-theme="light"] .ai-generated-disclosure--competencies {
  color: var(--kate-type-secondary) !important;
}
</style>

<script>
import { GENERATED_CONTENT_DISCLOSURE, AI_COMPETENCY_SELECTION_DISCLOSURE } from '@constants/ai-disclosure-copy';

const VARIANT_COPY = {
  content: GENERATED_CONTENT_DISCLOSURE,
  competencies: AI_COMPETENCY_SELECTION_DISCLOSURE,
};

export default {
  name: 'KAiGeneratedDisclosure',
  props: {
    variant: {
      type: String,
      default: 'content',
      validator: value => ['content', 'competencies'].includes(value),
    },
  },
  computed: {
    disclosureText() {
      return VARIANT_COPY[this.variant];
    },
  },
};
</script>
